import { Fragment, useRef, useState } from 'react';
import {
    SimpleForm, useTranslate,
    Toolbar, SaveButton, useCreate, ReferenceInput,
    useNotify, NumberInput,
    Button, AutocompleteInput, AutocompleteArrayInput,
    ReferenceArrayInput, useGetIdentity, Confirm,
    ReferenceField,
    TextField,
} from 'react-admin';

import { SectionField, ViewTitle } from '../../components';
import { makeStyles } from '@mui/styles';
import { Cancel, Send, Description } from '@material-ui/icons';
import { Dialog, DialogContent, DialogTitle, DialogActions } from '@material-ui/core';
import io from 'socket.io-client';
import axios from 'axios';
import CustomReferenceInput from '../../custom/customReferenceInput';
import { Box, IconButton, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import StatusProgress from '../../components/deploymentProgress';
import { Close } from '@mui/icons-material';

const BackendURL = process.env.REACT_APP_PROGRESS_URL; // Replace with your backend URL

const useStyles = makeStyles((theme) => ({
    toolbar: {
        display: 'flex',
    },
    spacer: {
        flex: 1,
    },
    buttonMarginLeft: {
        marginLeft: 10
    },
    inputPaddingRight: {
        paddingRight: 'unset'
    },
    flexBox: {
        width: 'auto',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    inputMarginLeft: {
        marginLeft: 40
    },
    color: {
        color: theme.palette.primary.main,
        backgroundColor: 'white',
        border: theme.palette.primary.main
    },
    templateInput: {
        width: '300px',  /* Adjust this to your desired width */
    },
}));

const Validate = (values) => {
    const errors = {};
    if (!values.trainingTemplate) errors.trainingTemplate = 'ra.validation.required';
    return errors;
};


const Deploy = (props) => {
    const [create] = useCreate();
    const notify = useNotify();
    const classes = useStyles();
    const translate = useTranslate();
    const [showDialog, setShowDialog] = useState(false);
    const [deploymentInitiated, setDeploymentInitiated] = useState(false);
    const [deployments, setDeployments] = useState({}); // Store deployment state for each tab
    const [showProgressDialog, setShowProgressDialog] = useState(false); // New dialog state
    const [progressData, setProgressData] = useState({ progress: 0, statusText: '', status: '' });
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const fullNameField = choice => `${choice.firstname} ${choice.lastname}`;
    const trainingTemplateId = props.trainingTemplateId;
    const trainingTemplateName = props.trainingTemplateName;
    const trainingTemplateStep = props.trainingTemplateStep;
    const trainingTemplateLanguage = props.trainingTemplateLanguage;
    const [open, setOpen] = useState(false);
    const [dialogData, setDialogData] = useState([]);
    const filterToQuery = searchText => ({ email: `${searchText}` });
    const filterToQueryName = searchText => ({ name: `${searchText}` });
    const optionRendererTrainingTemplate = choice => `${choice.name} #${choice.language} #${choice.step}`;
    const [selectedRoom, setSelectedRoom] = useState();
    const [socketRef, setSocketRef] = useState(null); // State to hold the socket reference
    const [deploymentLogs, setDeploymentLogs] = useState({});

    let classroomId;
    let classroomName;
    if (props.classroomId) {
        classroomId = props.classroomId;
        classroomName = props.classroomName
    }
    const { data: identity, isLoading, error } = useGetIdentity();

    if (isLoading) return <div>{translate('app.LoadingMessage')}</div>;

    const { id: userId } = identity;

    let postDefaultValue;
    if (props.trainingTemplateId || props.classroomId) {
        postDefaultValue = () => ({
            trainingTemplate: props.trainingTemplateId,
            room: props.classroomId,
        });
    }

    const handleDeployClick = () => {
        setOpen(true);
        console.log('open dialog form');
        setShowDialog(true);
        setShowProgressDialog(false); // Reset the progress dialog before initiating new deployment
        setTimeout(() => {
            setShowProgressDialog(true);  // Force re-render after a delay
        }, 100);
        setDeployments({});  // Clear previous deployments
        setDeployments({}); // Reset deployments state before starting a new one
    };

    const CloseConfirmDialog = () => {
        setShowConfirmDialog(false);
    };

    const closeSocket = () => {
        // Disconnect the socket when the dialog is closed
        try {
            console.log('WebSocket connection should be disconnected.');

            if (socketRef && socketRef.connected) {
                socketRef.disconnect();
                console.log('WebSocket connection disconnected.');
            }

            setShowProgressDialog(false);
        } catch (error) {
            console.error('Error disconnecting WebSocket:', error);
        }
    };

    const CreateToolbar = () => {

        return (
            <Toolbar className={classes.toolbar}>
                <Button color='primary' label="ra.action.cancel" size="medium" onClick={handleCloseClick} className={classes.color}>
                    <Cancel />
                </Button>
                <SaveButton label={translate('app.buttons.deploy')} className={classes.buttonMarginLeft} />
            </Toolbar>
        );
    };

    const HandleClassroomCheck = async (data) => {
        setDialogData(data);
        setSelectedRoom(data.room);
        try {
            const checkRoomResult = await CheckSessionData({ room: data.room });
            if (checkRoomResult) {
                handleCloseClick();
                setShowConfirmDialog(true);
            } else {
                trainingTemplateDeploy(data);
            }
        } catch (error) {
            console.error('Error during room check:', error);
            alert('Error occurred during room check.');
        }
    };

    const CheckSessionData = async ({ room }) => {
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get(`/api/v1/sessions`, {
                params: { filter: JSON.stringify({ room }) },
                headers: { Authorization: `Bearer ${token}` }
            });

            const sessionData = res.data;
            return sessionData && sessionData.totalResults > 0; // Check if the classroom is used
        } catch (error) {
            console.error('Error during room check:', error);
            return false;
        }
    };

    const handleCloseClick = () => {
        console.log('close dialog form', props.trainingTemplateId);
        setShowDialog(false);
    };

    // Handle confirmed deployment
    const handleConfirmDeployment = (data) => {
        setShowConfirmDialog(false);
        trainingTemplateDeploy(dialogData);
    };

    const handleCloseDialog = (deployments) => {
        const updatedDeployments = { ...deployments };
        delete updatedDeployments[userId];
        setDeployments(updatedDeployments);
        closeSocket();
    };


    const trainingTemplateDeploy = (data) => {

        const dataToSend = {
            room: data.room,
            trainingTemplate: data.trainingTemplate,
            pod_max: data.pod_max,
            trainer: data.trainer
        };

        deployProgress();

        // Open the progress dialog initially
        setShowProgressDialog(true);
        setDeploymentInitiated(true);
        create(`trainingTemplates/deploy`, { data: dataToSend }, {
            onSuccess: response => {

                if (!response) {
                    notify('ra.notification.created', 'info');

                } else {
                    notify(translate('app.trainingTemplates.deploy.successMessage'), { type: 'success' });
                };
            },
            onError: error => {
                if (error.message) {
                    notify(`${translate('app.trainingTemplates.deploy.errorMessage')}: ${error.message}`, { type: 'error' });
                }
                else {
                    notify(translate('app.trainingTemplates.deploy.errorMessage'), { type: 'error' });
                }
            }
        }
        );
        handleCloseClick();
    };

    const deployProgress = () => {
        if (!userId) {
            // If userId is not available, return early
            return;
        }

        const socket = io(BackendURL, {
            query: { userId }, // Pass the userId as a query parameter
        });

        socket.on('connect', () => {
            console.log('WebSocket connection established.');
        });

        socket.on('disconnect', () => {
            console.log('WebSocket connection closed.');
        });

        socket.emit('joinRoom', userId);

        // Event handler for 'deploymentProgress' event from the backend
        socket.on('deploymentProgress', ({ userId, progress, statusText, trainingId, status, error, podId }) => {
            // Append message to history
            setDeploymentLogs(prev => {
                const currentLogs = prev[userId] || [];
                return {
                    ...prev,
                    [userId]: [...currentLogs, { progress, statusText, status, error, podId }],
                };
            });

            // Optionally: still show latest summary in a separate state if you want
            setDeployments(prev => ({
                ...prev,
                [userId]: { progress, statusText, status, error },
            }));

            setShowProgressDialog(true);
        });

        setSocketRef(socket); // Store the socket reference in state
    };

    if (isLoading) return <div>{translate('app.LoadingMessage')}</div>;


    return (
        <Fragment>
            <Button label={translate('app.trainingTemplates.deploy.button')} onClick={handleDeployClick} style={props.style}><Send /></Button>

            <Dialog
                fullWidth
                open={showDialog}
                onClose={handleCloseClick}
                aria-label={translate('app.trainingTemplates.deploy.title')}
            >
                <DialogTitle>
                    <ViewTitle label={translate('app.trainingTemplates.deploy.title')} icon={Send} />
                </DialogTitle>
                <DialogContent>
                    <SimpleForm validate={Validate} toolbar={<CreateToolbar />} onSubmit={HandleClassroomCheck}
                        redirect="list" defaultValues={postDefaultValue} >
                        <SectionField label={translate('app.trainingTemplates.deploy.data')} icon={Description} />

                        {
                            classroomId ?
                                <AutocompleteInput source='room'
                                    label={translate('app.classrooms.title')} choices={[
                                        { id: classroomId, name: classroomName },
                                    ]} className={classes.templateInput} />
                                :
                                <ReferenceInput
                                    source="room"
                                    reference="classrooms"
                                     perPage= {100}
                                    label="room"
                                    sort={{
                                        field: 'name',
                                        order: 'ASC'
                                    }}
                                >
                                    <AutocompleteInput optionText="name" filterToQuery={filterToQueryName} className={classes.templateInput} />
                                </ReferenceInput>
                        }


                        {trainingTemplateId ?
                            <AutocompleteInput source='trainingTemplate'
                                label={translate('app.trainingTemplates.title')} choices={[
                                    { id: trainingTemplateId, name: trainingTemplateName, step: trainingTemplateStep, language: trainingTemplateLanguage },
                                ]} optionText={optionRendererTrainingTemplate} filterToQuery={filterToQueryName} className={classes.templateInput} />
                            :
                            <CustomReferenceInput
                                source="trainingTemplate"
                                reference="trainingTemplates"
                                label={translate('app.trainingTemplates.title')}
                                optionText={optionRendererTrainingTemplate}
                                className={classes.templateInput}
                                filterToQuery={filterToQueryName}
                            />
                        }


                        <NumberInput min='0' source="pod_max" max='8' sx={{ paddingRight: 'unset' }} className={classes.templateInput} />

                        <ReferenceArrayInput
                            source="trainer"
                            reference="users"
                            label="trainer"
                            filter={{ "roles": "trainer" }}
                        >
                            <AutocompleteArrayInput optionText={fullNameField} filterToQuery={filterToQuery} className={classes.templateInput} />
                        </ReferenceArrayInput>
                    </SimpleForm>
                </DialogContent>
            </Dialog>

            <Confirm
                isOpen={showConfirmDialog}
                title="Confirm deployment"
                content="This classroom is already used. Do you want to proceed with the deployment?"
                onConfirm={handleConfirmDeployment}
                onClose={CloseConfirmDialog}
            />

            {/* Render your progress bar or other UI elements */}
            {/* New Dialog to show progress and status */}
            {Object.keys(deployments).map((userId) => (
                <Dialog
                    key={userId}
                    fullWidth
                    open={showProgressDialog} // Show dialog based on deployment state
                    onClose={(event, reason) => {
                        if (reason === 'backdropClick') return; // ignore backdrop clicks
                        handleCloseDialog(deployments); // only close with ESC or manual button
                    }}
                    aria-label="Deployment Progress"
                >
                    <DialogTitle>
                        <SectionField label='Deployment Progress' icon={Send} />
                    </DialogTitle>
                    <DialogContent>
                        <StatusProgress
                            deployments={deployments}
                            deploymentLogs={deploymentLogs}
                            userId={userId}
                        />
                        {selectedRoom && (
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Link
                                    component={RouterLink}
                                    to={`/classrooms/${selectedRoom}/show`}
                                    sx={{ fontSize: '1.05rem', fontWeight: 500 }}
                                >
                                    View Classroom
                                </Link>
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: 'flex-start' }}>
                        <Button color='primary' label="ra.action.close" size="medium" onClick={() => handleCloseDialog(deployments)} className={classes.color}>
                            <Cancel />
                        </Button>
                    </DialogActions>
                </Dialog>
            ))}
        </Fragment>
    )
}

export default Deploy;
